import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Dispatch, SetStateAction } from 'react';
import { KaziModal } from './Kazi/KaziModal';
import { SetupForm } from '../Pages/Wallet/Components/SetupForm';
import { useAppDispatch, useAppSelector } from '../Redux/store';
import { useTheme } from '@mui/material';
import { AppSettings } from '../Utils/Settings';
import { setShowAddPaymentMethodModal } from '../Redux/slices/GlobalModalSlice';

const publishable_key = AppSettings.Stripe.PublishableKey;
const stripePromise = loadStripe(publishable_key);

interface AddPaymentMethodProps {}
export const AddPaymentMethod = ({}:AddPaymentMethodProps ) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const open = useAppSelector( state => state.GlobalModal.showAddPaymentMethodModal);
    const theme = useTheme();
    const { clientSecret, customerSessionClientSecret } = useAppSelector( state => state.Global);
    /* ******************** Variables ******************** */
    const options = {
        clientSecret: clientSecret!,
        customerSessionClientSecret: customerSessionClientSecret!,
        appearance:{
            variables: {
                colorPrimary: theme.palette.primary.main
            }
        }
    }
    /* ******************** Functions ******************** */
    const handleClose = () => {
        dispatch(setShowAddPaymentMethodModal(false))
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            sx={{
                overflowY: 'auto'
            }}
            content={
                <>
                    <Elements stripe={stripePromise} options={options}>
                        <SetupForm />
                    </Elements>
                </>
            }
            actions={[]}
        />
    )
}